import React from 'react';
import { useSelector } from 'react-redux';
import { getActiveMarker } from '@src/containers/Map/selectors/getActiveMarker';
import useFavourites from '@src/containers/Session/hooks/useFavourites';
import MapSlider from '..';

const MapSliderCDefault = (props) => {
	const activeMarker = useSelector(getActiveMarker);
	const { addSpaceToFavour, removeSpaceFromFavour } = useFavourites();
	const [initialOrder] = React.useState(
		activeMarker?.spaces.map(({ id }) => id),
	);

	const normalized = React.useMemo(() => {
		const result = {};
		activeMarker?.spaces.forEach((space) => {
			result[space.id] = space;
		});
		return result;
	}, [activeMarker?.spaces]);

	const handleClickLike = React.useCallback(
		(isLiked, id) => {
			if (!isLiked) {
				addSpaceToFavour({ id });
			} else {
				removeSpaceFromFavour({ id });
			}
		},
		[addSpaceToFavour, removeSpaceFromFavour],
	);

	const ordered = React.useMemo(() => {
		return initialOrder?.map((id) => {
			return normalized[id];
		});
	}, [normalized, initialOrder]);

	return (
		<MapSlider cards={ordered} onClickHeart={handleClickLike} {...props} />
	);
};

export default MapSliderCDefault;
